import { useTableLocalization } from "Infrastructure/Utilities/useTableLocalization";
import { alpha, type Theme } from "@mui/material";
import {
	MaterialReactTable,
	type MRT_RowData,
	type MRT_TableOptions,
	useMaterialReactTable,
} from "material-react-table";

const tableBodyStyles = (theme: Theme) => ({
	'& tr:nth-of-type(even):not([data-selected="true"]):not([data-pinned="true"]) > td':
		{
			backgroundColor: alpha(theme.palette.primary.main, 0.08),
		},
});

type TableProps<TData extends MRT_RowData> = {
	tableOptions: MRT_TableOptions<TData>;
};

export const Table = <TData extends MRT_RowData>({
	tableOptions,
}: TableProps<TData>) => {
	const { localization } = useTableLocalization();

	const table = useMaterialReactTable({
		enableStickyHeader: true,
		localization,
		paginationDisplayMode: "pages",
		muiTableBodyProps: {
			sx: tableBodyStyles,
		},
		muiTableContainerProps: {
			sx: {
				maxHeight: "none",
			},
		},
		...tableOptions,
	});

	return (
		<>
			<MaterialReactTable table={table} />
			{/* <Pagination /> */}
		</>
	);
};
